import ChangeNotificationStatus from 'owa-service/lib/contract/ChangeNotificationStatus';
import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to update change notification status
 */
export default mutatorAction(
    'updateChangeNotificationStatusInInitialState',
    function updateChangeNotificationStatusInInitialState(
        folderId: string,
        status: ChangeNotificationStatus
    ) {
        let store = getStore();
        store.initialState[folderId] = status;
    }
);
